import React, { useState, useRef } from "react";

import ChangePassword from "./ChangePassword";
import crossButton from '../assets/image/crossButton.svg'
import EditProfile from "./EditProfile";
import localStorageServices from "../../services/LocalStorage";
import { NavigationRoutes } from "../../constant/Routes";
import { useNavigate } from "react-router-dom";
import { connect, useSelector } from "react-redux";

import { logout } from "../../redux/actionDispatcher/auth/authDispatcher";
import { imageBaseUrls } from "../../constant/ApiUrls";
function AppHeaderDropDown({ logout }) {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const dropdownRef = useRef(null);
    const toggleDropdown = () => {
        setShow(!show);
    };
    const userData = useSelector((state) => state.auth.userInfo);
    console.log(`user data is this ${userData}`);
    // Close dropdown when clicking outside
    const logoutfunction = () => {
        logout();
        localStorageServices.clear();
        navigate(NavigationRoutes.LOGIN, { replace: true });
    };
    return (<>
        <div style={{ position: "relative", display: "inline-block" }} ref={dropdownRef} >
            {/* Profile Image with Tooltip */}
            <img
                onClick={toggleDropdown}
                src={`${imageBaseUrls(userData.image)}`} // Replace with actual profile image
                alt="Profile"
                title="View Profile"
                style={{
                    height: "42px",
                    width: "42px",
                    margin: "10px",
                    cursor: "pointer",
                    borderRadius: "50%",
                }}
            />

            {/* Profile Dropdown */}

            {show && (
                <div
                    style={{
                        position: "absolute",
                        textAlign: "center",
                        top: "50px",
                        right: "10px",
                        backgroundColor: "#7e84a3",
                        minHeight: "200px",
                        width: "250px",
                        borderRadius: "5px",
                        padding: "10px",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                        zIndex: 1000,
                    }}
                >
                    {/* Profile Info */}
                    <div  style={{ display: "flex", justifyContent: "flex-end" }}>
                        <img onClick={toggleDropdown}
                            src={crossButton} alt="close" className="cross-button" />
                    </div>
                    <div style={{ textAlign: "center", color: "white" }}>
                        <img
                            alt="Profile"
                            src={`${imageBaseUrls(userData.image)}`} // Replace with actual profile image
                            style={{
                                height: "82px",
                                width: "82px",
                                borderRadius: "50%",
                                marginBottom: "10px",
                            }}
                        />
                        <p>
                            <strong>{userData.name}</strong>
                            <br/>
                        <p style={{fontSize:"13Px"}}>{userData.email}</p>
                        </p>
                    </div>

                    <hr style={{ borderColor: "white", opacity: 0.5 }} />

                    <ChangePassword ></ChangePassword>
                    <EditProfile  />
                    {/* Logout Button */}

                    {/* Logout Button */}
                    <button
                        style={{
                            marginTop: "10px",
                            outline: "none",
                            color: "white",
                            backgroundColor: "red",
                            border: "1px solid red",
                            borderRadius: "4px",
                            height: "30px",
                            width: "100%",
                            fontSize: "14px",
                            cursor: "pointer",
                        }}
                        onClick={() => logoutfunction()}
                    >
                        Log out
                    </button>
                </div>
            )}
        </div>

    </>);
}
//Getting the state from the store
const mapStateToProps = (state) => {
    return {
        notifyData: state.activityStatus,
    };
};
//passing the userData in fetchUsers function and also dispatch method
const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => dispatch(logout()),

    };
};

//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(AppHeaderDropDown);
